import Cookies from 'js-cookie';
import { nanoid as createUniqueID } from 'nanoid';

export const requestName = `sessionId`;

export function createRequestId() {
  const requestId = Cookies.get(requestName);

  if (requestId) {
    return requestId;
  }

  const uuid = createUniqueID();
  Cookies.set(requestName, uuid);

  return uuid;
}

export function getRequestId() {
  return Cookies.get(requestName) || createRequestId();
}
